import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import cdi from './CatalogDisplayItem.module.scss';
import { Button, Flex, Layout, Skeleton, Typography } from 'antd';
import Image from 'next/image';
import g from '../../general.module.scss';
import {
    ECatalogDisplayItemType,
    ECatalogDisplayViewType,
    EPopupNotificationType,
    EProfileType,
} from 'tkmp-lib/src/enums';
import { useRouter } from 'next/router';
import { useStores } from '@/utils/hooks/useStores';
import { observer } from 'mobx-react-lite';
import { ICatalogDisplayItemProps } from 'tkmp-lib/src/interfaces';
import { CompareButton, FavouriteButton, ImageButton } from '@/widgets/ItemButtons/ItemButtons';
import { usePopup } from 'tkmp-lib/src/hooks/usePopup';
import { AuthService } from 'tkmp-lib/src/services/AuthService';
import { QueryService } from 'tkmp-lib/src/services/QueryService';
import { getCookie } from 'cookies-next';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

// @ts-ignore
const CatalogDisplayItem = observer(
    ({
        element,
        cid,
        isFavouriteInitial,
        isCompareInitial,
        type = ECatalogDisplayItemType.Custom,
        customActions = { favourite: true, compare: true, basket: true, children: [] },
    }: ICatalogDisplayItemProps) => {
        // @ts-ignore
        const router = useRouter();
        const {
            systemStore: { CATALOG_DISPLAY_TYPE },
            userStore: { USERROLE },
            modalsStore: { openRegisterForm, openLoginForm, openUnaccessedForm },
        } = useStores();
        const LOCALIZATION = useLocalization();
        const { notification } = usePopup();
        // console.log('element', element);
        const [userRole, setUserRole] = useState<EProfileType>(EProfileType.Unknown);
        // переменная с полными данными товаров (включая описание)
        const [fullElementData, setFullElementData] = useState<any>(null);

        useEffect(() => {
            setUserRole(USERROLE === '' ? EProfileType.Unknown : (USERROLE as EProfileType));
        }, [USERROLE]);

        const [isGrid, setIsGrid] = useState(CATALOG_DISPLAY_TYPE === ECatalogDisplayViewType.Grid);

        useEffect(() => {
            setIsGrid(CATALOG_DISPLAY_TYPE === ECatalogDisplayViewType.Grid);
        }, [CATALOG_DISPLAY_TYPE]);
        // для
        useEffect(() => {
            QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/product/${element.slug}`,
            ).then((response: any) => {
                setFullElementData({
                    ...element,
                    description: response?.info.description,
                });
                // console.log({
                //     ...element,
                //     description: response.info.description
                // })
            });
        }, []);
        let itemStyle = {};

        if (type !== ECatalogDisplayItemType.Catalog)
            itemStyle = { ...itemStyle, border: '1px solid #ACAEB0' };
        if (isGrid)
            itemStyle = { ...itemStyle, maxWidth: '260px', minWidth: '260px', maxHeight: '360px' };

        const [isPendingToggle, setIsPendingToggle] = useState<boolean>(false);
        const [isFavourite, setIsFavourite] = useState<boolean>(isFavouriteInitial ?? false);
        const [isCompare, setIsCompare] = useState<boolean>(isCompareInitial ?? false);
        const [isBasket, setIsBasket] = useState<boolean>(false);
        const addToCart = (orgSlug: string, prodSlug: string) => {
            AuthService.validateAuth().then((answer) => {
                if (answer) {
                    QueryService.request(
                        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/basket/item`,
                        {
                            method: 'PUT',
                            headers: {
                                Authorization: `Bearer ${getCookie('accessToken')}`,
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                orgSlug: orgSlug,
                                prodSlug: prodSlug,
                                count: isBasket ? 0 : 1,
                            }),
                        },
                    ).then((_) => {
                        setIsBasket(!isBasket);
                        if (typeof window !== 'undefined')
                            notification.success({
                                message:
                                    LOCALIZATION.pages.product.notification.changeBasketProduct
                                        .message,
                                description: !isBasket
                                    ? LOCALIZATION.pages.product.notification.changeBasketProduct
                                          .notSelected
                                    : LOCALIZATION.pages.product.notification.changeBasketProduct
                                          .selected,
                            });
                    });
                } else {
                    AuthService.logout();
                }
            });
        };
        const toggleFavourite = () => {
            setIsPendingToggle(true);
            AuthService.validateAuth().then((answer) => {
                if (answer) {
                    QueryService.request(
                        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/favourite/item`,
                        {
                            method: isFavourite ? 'DELETE' : 'PUT',
                            headers: {
                                Authorization: `Bearer ${getCookie('accessToken')}`,
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                slug: fullElementData?.slug,
                                name: fullElementData?.name,
                                article: fullElementData?.article,
                                description: fullElementData?.description,
                                logo: fullElementData?.icon,
                            }),
                        },
                    ).then((answer) => {
                        if (!answer || answer.error) {
                            notification.error({
                                message:
                                    LOCALIZATION.widgets.CatalogDisplayItem.notifications.error
                                        .message,
                                description:
                                    LOCALIZATION.widgets.CatalogDisplayItem.notifications.error
                                        .description,
                            });
                        } else {
                            if (typeof window !== 'undefined')
                                notification.success({
                                    message:
                                        LOCALIZATION.widgets.CatalogDisplayItem.notifications
                                            .favourite.message,
                                    description: !isFavourite
                                        ? LOCALIZATION.widgets.CatalogDisplayItem.notifications
                                              .favourite.descriptionTrue
                                        : LOCALIZATION.widgets.CatalogDisplayItem.notifications
                                              .favourite.descriptionFalse,
                                });
                            // console.log(isFavourite)
                            setIsFavourite((prevState) => !prevState);
                            setIsPendingToggle(false);
                        }
                    });
                } else {
                    setIsPendingToggle(false);
                    AuthService.logout();
                }
            });
        };
        const toggleCompare = (productSlug: string, distributorSlug: string) => {
            setIsPendingToggle(true);
            AuthService.validateAuth().then((answer) => {
                if (answer) {
                    QueryService.request(
                        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/compare/item`,
                        {
                            method: isCompare ? 'DELETE' : 'PUT',
                            headers: {
                                Authorization: `Bearer ${getCookie('accessToken')}`,
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                productSlug: productSlug,
                                distributorSlug: distributorSlug,
                            }),
                        },
                    ).then((answer) => {
                        if (answer?.error) {
                            notification.error({
                                message:
                                    LOCALIZATION.widgets.CatalogDisplayItem.notifications.error
                                        .message,
                                description:
                                    LOCALIZATION.widgets.CatalogDisplayItem.notifications.error
                                        .description,
                            });
                        } else {
                            if (typeof window !== 'undefined')
                                notification.success({
                                    message:
                                        LOCALIZATION.widgets.CatalogDisplayItem.notifications
                                            .compare.message,
                                    description: !isCompare
                                        ? LOCALIZATION.widgets.CatalogDisplayItem.notifications
                                              .compare.descriptionTrue
                                        : LOCALIZATION.widgets.CatalogDisplayItem.notifications
                                              .compare.descriptionFalse,
                                });
                            setIsCompare((prevState) => !prevState);
                            setIsPendingToggle(false);
                        }
                    });
                } else {
                    setIsPendingToggle(false);
                    AuthService.logout();
                }
            });
        };
        // console.log(LOCALIZATION.widgets)
        useEffect(() => {
            QueryService.request(
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${LOCALIZATION.locale}/profile/basket`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getCookie('accessToken')}`,
                    },
                },
            ).then((response: any) => {
                setIsBasket(
                    response?.items?.some((orgItem: any) =>
                        orgItem.items?.some(
                            (item: any) => item.tool.slug === fullElementData?.slug,
                        ),
                    ),
                );
            });
        }, [fullElementData]);
        // @ts-ignore
        return (
            <Layout
                className={`${cdi.item} ${isGrid ? cdi.column : cdi.line}`}
                style={itemStyle}
            >
                {isGrid && (
                    <Flex className={cdi.item_article}>
                        <Typography.Text className="text-12-400 text-[#7B7C7D]">
                            {LOCALIZATION.widgets.CatalogDisplayItem.article}
                            {fullElementData?.article}
                        </Typography.Text>
                    </Flex>
                )}
                <Layout
                    className={`${cdi.item_imageBlock} ${!isGrid && cdi.item_imageBlock__inline}`}
                >
                    {fullElementData?.logo !== undefined ? (
                        <Link href={`/product/${fullElementData?.slug}`}>
                            <Image
                                priority={false}
                                width={isGrid ? 162 : 111}
                                height={isGrid ? 162 : 111}
                                sizes={'100%'}
                                alt={''}
                                style={{ margin: '0 auto' }}
                                src={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${fullElementData?.logo}`}
                            />
                        </Link>
                    ) : (
                        <Skeleton.Image
                            style={{ height: '162px', width: '224px' }}
                            active={true}
                        />
                    )}
                    {isGrid && (
                        <Flex className={cdi.item_imageBlock__controls}>
                            {customActions?.favourite && (
                                <FavouriteButton
                                    disabled={isPendingToggle}
                                    width={32}
                                    height={32}
                                    active={isFavourite}
                                    onClick={() => {
                                        if ((userRole as EProfileType) === EProfileType.Unknown) {
                                            openLoginForm();
                                        } else if (
                                            (userRole as EProfileType) === EProfileType.Buyer
                                        ) {
                                            toggleFavourite();
                                        } else {
                                            openUnaccessedForm();
                                        }
                                    }}
                                />
                            )}
                            {customActions?.compare && (
                                <CompareButton
                                    disabled={isPendingToggle}
                                    width={32}
                                    height={32}
                                    active={isCompare}
                                    onClick={() => {
                                        if ((userRole as EProfileType) === EProfileType.Unknown) {
                                            openLoginForm();
                                        } else if (
                                            (userRole as EProfileType) === EProfileType.Buyer
                                        ) {
                                            toggleCompare(
                                                fullElementData?.slug,
                                                fullElementData?.manufactureSlug ?? '',
                                            );
                                        } else {
                                            openUnaccessedForm();
                                        }
                                    }}
                                />
                            )}
                            {customActions?.children &&
                                customActions?.children?.map((button: any, i) => (
                                    <ImageButton
                                        key={i}
                                        icon={button?.icon}
                                        active={button?.isActive}
                                        onClick={() => button?.onClick()}
                                        width={32}
                                        height={32}
                                    />
                                ))}
                        </Flex>
                    )}
                </Layout>
                <Layout className={cdi.item_descriptionBlock}>
                    {!isGrid && (
                        <Flex style={{ paddingBottom: 16, background: 'transparent' }}>
                            <Typography.Text className={`text-12-400 `}>
                                {LOCALIZATION.widgets.CatalogDisplayItem.article}
                                {fullElementData?.article === 'null'
                                    ? '0000'
                                    : fullElementData?.article}
                            </Typography.Text>
                        </Flex>
                    )}
                    {/*<Layout className={`${s.starFlex}`} style={!CATALOG_DISPLAY_TYPE_GRID ? {justifyContent: 'flex-start'} : {}}>*/}
                    {/*    <div className={cicss.rating} style={{'--rate': '4.7'}}>*/}
                    {/*        <div className={cicss.star}></div>*/}
                    {/*        <div className={cicss.star}></div>*/}
                    {/*        <div className={cicss.star}></div>*/}
                    {/*        <div className={cicss.star}></div>*/}
                    {/*        <div className={cicss.star}></div>*/}
                    {/*    </div>*/}
                    {/*    <div>*/}
                    {/*        <span className="text-12-400">{element?.itemRateCount || 4.7}</span>*/}
                    {/*    </div>*/}
                    {/*</Layout>*/}
                    <Layout
                        className={`${cdi.slTexLink}`}
                        style={isGrid ? {} : { alignItems: 'flex-start' }}
                    >
                        <Link
                            className={`${cdi.productTitleLink} ${!isGrid ? cdi.productTitleLinkInline : ''} text-16-400`}
                            href={`/product/${fullElementData?.slug}`}
                            style={{
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                width: '100%',
                            }}
                        >
                            {fullElementData?.name}
                        </Link>
                        <Button
                            type="text"
                            className={`
                                ${g.button_link}
                                !text-14-400 
                                !text-[#8D24F8] 
                                !text-left 
                                !block   
                                !truncate
                            `}
                            style={{
                                display: 'inline-block',
                                maxWidth: '100%',
                                height: 'auto',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                textAlign: 'left',
                                borderRadius: '3px',
                            }}
                            onClick={() => {
                                router.push({
                                    pathname: `/manufacturer/${fullElementData?.manufactureSlug}`,
                                });
                            }}
                        >
                            {fullElementData?.manufactureAlias ||
                                LOCALIZATION.widgets.CatalogDisplayItem.manufacturer}
                        </Button>
                    </Layout>
                    {fullElementData?.offerCount > 1 && (
                        <Button
                            className={`${g.button_link} text-14-400`}
                            style={{ alignSelf: 'start' }}
                            type={'text'}
                        >
                            +{fullElementData?.offerCount}
                            {LOCALIZATION.widgets.CatalogDisplayItem.offers}
                            {fullElementData?.offerMinValue} {fullElementData?.currency}
                        </Button>
                    )}
                </Layout>
                <Layout
                    className={`${cdi.item_additionBlock} ${CATALOG_DISPLAY_TYPE === ECatalogDisplayViewType.List ? cdi.additionBlockLine : cdi.additionBlockColumn}`}
                >
                    <Typography.Text
                        className={cdi.item_additionBlock__price}
                        style={{ fontWeight: 500 }}
                    >
                        {fullElementData?.offerMinValue
                            ? `${fullElementData?.offerMinValue} ${fullElementData?.currency}`
                            : LOCALIZATION.widgets.CatalogDisplayItem.POA}
                    </Typography.Text>
                    {!isGrid && fullElementData?.offerCount > 1 && (
                        <Button
                            className={`${g.button_link} text-12-400`}
                            style={{ alignSelf: 'start' }}
                            type={'text'}
                        >
                            +{fullElementData?.offerCount}
                            {LOCALIZATION.widgets.CatalogDisplayItem.offers}
                            {fullElementData?.offerMinValue} {fullElementData?.currency}
                        </Button>
                    )}
                    <Layout
                        className={cdi.item_additionBlock__controls}
                        style={
                            CATALOG_DISPLAY_TYPE === ECatalogDisplayViewType.List
                                ? { flexDirection: 'row', flexGrow: '0' }
                                : {}
                        }
                    >
                        <Button
                            type={isBasket ? 'primary' : 'default'}
                            style={{ width: isGrid ? '100px' : '316px' }}
                            onClick={() => {
                                if ((userRole as EProfileType) === EProfileType.Unknown) {
                                    openLoginForm();
                                } else if ((userRole as EProfileType) === EProfileType.Buyer) {
                                    addToCart(
                                        fullElementData?.manufactureSlug,
                                        fullElementData?.slug,
                                    );
                                } else {
                                    openUnaccessedForm();
                                }
                            }}
                        >
                            {isBasket
                                ? LOCALIZATION.widgets.CatalogDisplayItem.removeCart
                                : LOCALIZATION.widgets.CatalogDisplayItem.addToCart}
                        </Button>
                        {!isGrid && (
                            <Flex
                                style={{ background: 'transparent' }}
                                gap={'small'}
                            >
                                {customActions?.favourite && (
                                    <FavouriteButton
                                        disabled={isPendingToggle}
                                        width={32}
                                        height={32}
                                        active={isFavourite}
                                        onClick={() => {
                                            if (
                                                (userRole as EProfileType) === EProfileType.Unknown
                                            ) {
                                                openLoginForm();
                                            } else if (
                                                (userRole as EProfileType) === EProfileType.Buyer
                                            ) {
                                                toggleFavourite();
                                            } else {
                                                openUnaccessedForm();
                                            }
                                        }}
                                    />
                                )}
                                {customActions?.compare && (
                                    <CompareButton
                                        disabled={isPendingToggle}
                                        width={32}
                                        height={32}
                                        active={isCompare}
                                        onClick={() => {
                                            if (
                                                (userRole as EProfileType) === EProfileType.Unknown
                                            ) {
                                                openLoginForm();
                                            } else if (
                                                (userRole as EProfileType) === EProfileType.Buyer
                                            ) {
                                                toggleCompare(
                                                    fullElementData?.slug,
                                                    fullElementData?.manufactureSlug ?? '',
                                                );
                                            } else {
                                                openUnaccessedForm();
                                            }
                                        }}
                                    />
                                )}
                                {customActions?.children &&
                                    customActions?.children?.map((button: any, i) => (
                                        <ImageButton
                                            key={i}
                                            icon={button?.icon}
                                            active={button?.isActive}
                                            onClick={() => button?.onClick()}
                                            width={32}
                                            height={32}
                                        />
                                    ))}
                            </Flex>
                        )}
                    </Layout>
                </Layout>
            </Layout>
        );
    },
);

export default CatalogDisplayItem;
